import axios from './configObra/config-obra'

const defaultRoute = '/empresa-parceira'

export default {
  list: async () => {
    const data = axios.get(`${defaultRoute}`)
    
    return data
  },
  consulting: async (filial) => {
    const data = axios.get(`${defaultRoute}/list`, { params: { filial } })
  
    return data
  },
  create: async (empresa) => {
    const data = await axios.post(defaultRoute, empresa)

    return data
  },
  update: async (id, empresa) => {
    const data = axios.patch(`${defaultRoute}/${id}`, empresa)

    return data
  },
  remove: async (id) => {
    const data = axios.delete(`${defaultRoute}/${id}`)

    return data
  },

  // colaboradores
  listColaboradoresEmpresa: async (idEmpresa) => {
    const data = axios.get(`${defaultRoute}/${idEmpresa}/colaboradores`)

    return data
  },

  listDetailsColaborador: async (idColaborador) => {
    const data = axios.get(`${defaultRoute}/colaborador/${idColaborador}`)

    return data
  },

  createColaborador: async (colaborador) => {
    const data = axios.post(`${defaultRoute}/colaborador`, colaborador)

    return data
  },

  updateColaborador: async (colaborador) => {
    const data = axios.patch(`${defaultRoute}/${colaborador}/colaborador`)

    return data
  },
}
